import { useState } from 'react';
import ToggleStandardPlansView from './ToggleStandardPlans.View';
import { Plan, SubscriptionType } from 'types/billing';
import { useBillingCurrentPlan } from 'components/Billing/useBillingCurrentPlan';

const ToggleStandardPlans = (props: { subscription: SubscriptionType }) => {
  const { subscription } = props;

  const billingPlanDefs = useBillingCurrentPlan(subscription);
  const { isCancelled, isTrial, isMonthly } = billingPlanDefs;
  let defaultSelection = Plan.MonthByMonth;

  if (isMonthly) defaultSelection = Plan.Annual;
  if (isCancelled) defaultSelection = Plan.MonthByMonth;
  if (isTrial) defaultSelection = Plan.MonthByMonth;

  const [billingFrequency, setBillingFrequency] = useState<Plan>(defaultSelection);

  return (
    <ToggleStandardPlansView
      billingPlanOpts={billingPlanDefs}
      billingFrequency={billingFrequency}
      setBillingFrequency={setBillingFrequency}
    />
  );
};

export default ToggleStandardPlans;
